import api from "api"
import client from "dataCmsClient"
import { gql } from "graphql-request"

export async function loadAllMinicourses(store) {
  try {
    const data = await client.request(gql`
      {
        allMinicourses(first: 100) {
          id
          title
          description
          duration
          coverImage {
            url
          }
        }
      }
    `)
    await store.update(state => {
      state.allMinicourses = data.allMinicourses
    })
    loadUserMinicourse(store)
  } catch (error) {
    await store.update(state => {
      state.allMinicourses = []
    })
  }
}

export async function loadMinicourse(store, courseId) {
  try {
    const data = await client.request(gql`
    {
      minicourse(filter: { id: { eq: "${courseId}" } }) {
        id
        title
        highlights
        duration
        quiz {
          title
          url
        }
        video {
          video {
            url
          }
        }
        article {
          title
          lead
          content
        }
      }
    }`)
    await store.update(state => {
      state.minicourses[courseId] = data.minicourse
    })
    userOpenedCourse(courseId)
  } catch (error) {
    await store.update(state => {
      state.minicourses[courseId] = {}
    })
  }
}

export async function loadUserMinicourse(store) {
  const data = await api.get(`datocms/minicourse`)
  const allMinicourses = store.getState("allMinicourses")
  data.forEach(course => {
    allMinicourses.forEach((el, index) => {
      if (el.id === course.id) {
        store.update(state => {
          state.allMinicourses[index].completed = course.completed_at ? 100 : 0
        })
      }
    })
  })
}

export async function userOpenedCourse(courseId) {
  await api.post(`datocms/minicourse/${courseId}`, undefined, {
    status: "opened"
  })
}

export async function userCompletedCourse(store, courseId, response_id) {
  await api.post(`datocms/minicourse/${courseId}`, undefined, {
    status: "completed",
    verifier: `typeform:${response_id}`
  })
  const allMinicourses = store.getState("allMinicourses")
  if (!allMinicourses) return
  const index = allMinicourses.map(el => el.id).indexOf(courseId)
  await store.update(state => {
    state.allMinicourses[index].completed = 100
  })
}
